var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformanceCalcIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3727",
    "data-name": "Rectangle 3727",
    width: 50,
    height: 60,
    transform: "translate(253 2059)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_581",
    "data-name": "Mask Group 581",
    transform: "translate(-253 -2059)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BPD-icon2-pro-35",
    transform: "translate(252.997 2064.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M35.62,3.62,24.363,48.783h.551A23.856,23.856,0,0,0,35.62,3.62",
    fill: "#f6911e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M24.918,1.08a23.854,23.854,0,1,0-.551,47.706L35.62,3.62a23.777,23.777,0,0,0-10.7-2.54",
    fill: "#f18122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M27,24.044l-.874-.533V15.668c1.6.039,3.353.188,4.52.267h.057a.477.477,0,0,0,.525-.49V14.133c0-.306-.214-.437-.525-.525a44.875,44.875,0,0,0-4.485-.4V10.649a.616.616,0,0,0-.634-.595H24.144a.621.621,0,0,0-.616.616v2.623C20,13.731,18,15.449,18,18.645c0,2.457,1.412,4.026,4.24,5.749l1.368.831V34c-1.39-.035-3.235-.162-4.455-.267H19.06a.477.477,0,0,0-.525.49v1.263c0,.337.061.437.586.551a26.492,26.492,0,0,0,4.372.437V39.24a.616.616,0,0,0,.616.612h1.443a.616.616,0,0,0,.616-.612v-2.9c4.428-.612,5.622-3.41,5.622-6.024,0-2.461-1.259-4.149-4.809-6.269m-6.16-5.408c0-1.784.874-2.623,2.8-2.881v6.256c-1.941-1.22-2.8-2.055-2.8-3.375m5.29,15.191V26.763c2.1,1.364,2.8,2.186,2.8,3.554a3.133,3.133,0,0,1-2.8,3.5",
    fill: "#e2ded6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M38.645,4.048A25.023,25.023,0,0,0,5.421,9.46L4.013,8.682l-.079-.039h0a1.207,1.207,0,0,0-.7-.109,1.242,1.242,0,0,0-1.054,1.4l.59,4.516a1.246,1.246,0,0,0,.555.874l.074.044a1.25,1.25,0,0,0,1.115.052L8.7,13.552A1.25,1.25,0,0,0,9.342,11.9a1.224,1.224,0,0,0-.437-.516h0a1.517,1.517,0,0,0-.162-.092l-1.106-.612A22.492,22.492,0,0,1,46.776,30.662a1.246,1.246,0,1,0,2.413.625A24.953,24.953,0,0,0,38.645,4.048",
    fill: "#b2a9a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M47.428,35.052a1.25,1.25,0,0,0-1.749-.975L41.491,35.93a1.246,1.246,0,0,0-.175,2.186.761.761,0,0,0,.144.079l1.207.669A22.488,22.488,0,0,1,3.226,19.3a1.246,1.246,0,0,0-2.409-.63A24.979,24.979,0,0,0,44.879,40.088l1.346.752h.022a1.228,1.228,0,0,0,.713.114,1.246,1.246,0,0,0,1.067-1.4Z",
    fill: "#b2a9a1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceCalcIcon);
export default __webpack_public_path__ + "static/media/performance-calc-icon.ba60b9124d7d3af86332239a566cd37f.svg";
export { ForwardRef as ReactComponent };